import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ChatWelcomeMessageProps } from '@/storybook/components/AiChatDrawer/components/ChatWelcomeMessage/ChatWelcomeMessage';
import { buildChatbotFilterChipGroups } from '../utils/buildChatbotFilterChips';
import useActiveFiltersForChatbot from './useActiveFiltersForChatbot';

const useChatbotWelcome = (onQuestionClick: (question: string) => void): ChatWelcomeMessageProps => {
  const { t } = useTranslation();
  const activeFilters = useActiveFiltersForChatbot();

  return useMemo(() => {
    const { globalFilters, localFilters } = buildChatbotFilterChipGroups(activeFilters, t);

    return {
      globalFilters,
      localFilters,
      questions: [
        t('components.aiChatDrawer.quickQuestions.suggestions.overview'),
        t('components.aiChatDrawer.quickQuestions.suggestions.trends'),
        t('components.aiChatDrawer.quickQuestions.suggestions.priorities'),
        t('components.aiChatDrawer.quickQuestions.suggestions.segments'),
        t('components.aiChatDrawer.quickQuestions.suggestions.actions'),
      ],
      onQuestionClick,
    };
  }, [activeFilters, onQuestionClick, t]);
};

export default useChatbotWelcome;
